// 保险区域 vs 服务区城市匹配检查（保险预警页与车辆保险列表共用）
import { SearchServiceAreas } from "@/api/all"

// 区域检查结果状态定义
const AREA_CHECK_RESULTS = ["匹配失败", "一致", "不一致"]

export default {
    data() {
        return {
            // 服务区城市数据（区域检查依据，组件挂载时调用 loadServiceAreaCityData 加载）
            serviceAreaCityData: []
        }
    },
    methods: {
        // 加载服务区城市数据
        async loadServiceAreaCityData() {
            try {
                const response = await SearchServiceAreas({
                    platform: "",
                    isActive: null,
                    city: "",
                    cityCode: ""
                })
                this.serviceAreaCityData = response || []
            } catch (error) {
                console.error('获取服务区城市数据失败:', error)
                this.serviceAreaCityData = []
            }
        },
        // 检查区域匹配结果
        // 返回值: "匹配失败", "一致", "不一致"
        checkAreaMatch(platform, area, insuranceArea) {
            // 如果保险区域为空，返回匹配失败
            if (!insuranceArea) {
                return AREA_CHECK_RESULTS[0]
            }
            // 如果保险区域包含"中华人民共和国"，返回一致
            if (insuranceArea.includes("中华人民共和国")) {
                return AREA_CHECK_RESULTS[1]
            }
            // 如果没有服务区城市数据，返回匹配失败
            if (!this.serviceAreaCityData || this.serviceAreaCityData.length === 0) {
                return AREA_CHECK_RESULTS[0]
            }
            // 根据平台和服务区查找对应的服务区城市配置
            const matchedConfig = this.serviceAreaCityData.find(item => item.platform === platform && item.name === area)
            // 如果没有找到对应的配置，或city为空，返回匹配失败
            if (!matchedConfig || !matchedConfig.city) {
                return AREA_CHECK_RESULTS[0]
            }
            // 保险区域包含在city内，返回一致
            if (matchedConfig.city.includes(insuranceArea)) {
                return AREA_CHECK_RESULTS[1]
            }
            // 不相同则显示不一致
            return AREA_CHECK_RESULTS[2]
        },
        // 获取区域检查结果的标签类型
        getAreaCheckTagType(platform, area, insuranceArea) {
            const result = this.checkAreaMatch(platform, area, insuranceArea)
            if (result === AREA_CHECK_RESULTS[0]) {
                return "info" // 匹配失败 - 灰色
            } else if (result === AREA_CHECK_RESULTS[1]) {
                return "success" // 一致 - 绿色
            } else {
                return "danger" // 不一致 - 红色
            }
        },
        // 区域检查结果 tag 的 tooltip 文案：按结果说明判定原因（两页共用，措辞一致）
        buildAreaCheckTip(platform, area, insuranceArea) {
            const result = this.checkAreaMatch(platform, area, insuranceArea)
            if (result === '不一致') return `保险区域与服务区【${area}】不匹配`
            if (result === '一致') return `保险区域与服务区【${area}】匹配`
            return insuranceArea ? `缺少服务区【${area}】的城市配置，无法比对` : '无保险区域，无法与服务区比对'
        }
    }
}
